import { createAction } from '@reduxjs/toolkit';

import { IPurchaseState } from '../types';

export class GetPaymentLinkYookassaFailure {
  static get action() {
    return createAction('purchase/GET_PAYMENT_LINK_YOOKASSA_FAILURE');
  }

  static get reducer() {
    return (draft: IPurchaseState) => {
      draft.requests.getPaymentLinkPending = false;

      return draft;
    };
  }
}
